import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AdminWaitlist from "./pages/AdminWaitlist";
import AdminLogin from "./pages/AdminLogin";
import ContactPage from "./pages/ContactPage";
import FAQPage from "./pages/FAQPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";
import ResourcesPage from "./pages/ResourcesPage";
import AboutPage from "./pages/AboutPage";
import CharitiesPage from "./pages/CharitiesPage";
import { usePageviewTracker } from "./components/Analytics";

const API_URL = process.env.REACT_APP_BACKEND_URL;

function PageviewTracker() {
  usePageviewTracker();
  return null;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
    const lp = document.querySelector('.landing-page');
    if (lp) lp.scrollTop = 0;
  }, [pathname]);
  return null;
}

function ProtectedRoute({ children }) {
  const [auth, setAuth] = useState(null); // null = checking

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (!token) { setAuth(false); return; }
    fetch(`${API_URL}/api/auth/me`, {
      headers: { 'Authorization': `Bearer ${token}` },
    })
      .then(res => res.ok ? res.json() : Promise.reject())
      .then(() => setAuth(true))
      .catch(() => { localStorage.removeItem('admin_token'); setAuth(false); });
  }, []);

  if (auth === null) return <div className="admin-loading">Checking authentication...</div>;
  if (auth === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <PageviewTracker />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/charities" element={<CharitiesPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/waitlist" element={<ProtectedRoute><AdminWaitlist /></ProtectedRoute>} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/resources" element={<ResourcesPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
